var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 22.5C45 16.5317 42.629 10.81 38.4094 6.59062C34.1898 2.37108 28.4684 0 22.5 0C16.5316 0 10.81 2.37101 6.59062 6.59062C2.37108 10.8102 0 16.5316 0 22.5C0 28.4684 2.37101 34.19 6.59062 38.4094C10.8102 42.6289 16.5316 45 22.5 45C28.4684 45 34.19 42.629 38.4094 38.4094C42.6289 34.1898 45 28.4684 45 22.5ZM22.4131 33.3996C21.7225 33.3996 21.1632 32.8403 21.1606 32.1497V15.9304L15.6859 21.3998C15.1976 21.8882 14.4046 21.8882 13.9162 21.3998C13.4278 20.9114 13.4278 20.1185 13.9162 19.6301L21.5805 11.9658H21.5831C21.8168 11.7321 22.1345 11.5982 22.468 11.5982C22.7989 11.5982 23.1166 11.7321 23.3529 11.9658L31.0831 19.6986C31.3168 19.9323 31.448 20.2527 31.448 20.5835C31.448 20.9144 31.3168 21.2321 31.0831 21.4684C30.8467 21.7021 30.529 21.8334 30.1982 21.8334C29.8647 21.8334 29.547 21.7021 29.3133 21.4684L23.668 15.8231V32.1606L23.6654 32.158C23.6654 32.8486 23.1061 33.4079 22.4155 33.4079L22.4131 33.3996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.5e428aced1dbbed79c50a8e0ead3dd58.svg";
export { ForwardRef as ReactComponent };